/* tslint:disable */
/* eslint-disable */
export enum AVGSemScope {
  SisStudent = 'sis.student',
  SisTeacher = 'sis.teacher',
  SisGroup = 'sis.group',
  SisStudentTeacherDelivery = 'sis.student-teacher-delivery'
}
